import Body from './body';

export default Body;